import config from 'ra-config'
import normalizeUrl from 'normalize-url'

export function coreSiteUrl(path) {
  return normalizeUrl(`${config.env.coreSiteBaseUrl}/${path}`, {
    stripFragment: false,
    stripWWW: false
  })
}

export function rafiSiteUrl(path) {
  return normalizeUrl(`${config.env.rafiSiteBaseUrl}/${path}`, {
    stripFragment: false,
    stripWWW: false
  })
}

export function interactiveSiteUrl(path) {
  return normalizeUrl(`${config.env.interactiveSiteBaseUrl}/${path}`, {
    stripFragment: false,
    stripWWW: false
  })
}


// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/config/url.js